import {gsap} from "gsap"
import {ScrollTrigger} from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export const searchFormAnimations = {
    searchForm: document.querySelector('#buenaonda__search__form'),
    endTrigger: document.querySelector('#woocommerceProductsContainer'),
    searchFormHeight: 100,
    actionsOnEnter() {
        this.searchForm.style.zIndex = '9999'
        this.searchForm.classList.add('shadow-xl')
    },
    actionsOnLeave() {
        this.searchForm.classList.remove('shadow-xl')
    },
    bind() {
        if (!this.searchForm || !this.endTrigger) return;
        gsap.matchMedia().add('(min-width: 782px)', () => {
            this.searchFormHeight = 100;
            gsap.from(this.searchForm, {
                scrollTrigger: {
                    trigger: this.searchForm,
                    endTrigger: this.endTrigger,
                    start: 'top top+=10px',
                    end: `bottom top+=${this.searchFormHeight}px`,
                    scrub: true,
                    invalidateOnRefresh: true,
                    pin: true,
                    pinSpacing: false,
                    markers: false,
                    onEnter: () => this.actionsOnEnter(),
                    onEnterBack: () => this.actionsOnEnter(),
                    onLeave: () => this.actionsOnLeave(),
                    onLeaveBack: () => this.actionsOnLeave(),
                }
            })
        })
    }
};